import { useMutation } from '@tanstack/react-query';
import { uploadOrgLogoPromise, type UploadOrgLogoParam } from 'src/utils';
import { useNotification } from 'src/hooks/use-notification';

export const useUploadOrgLogo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: uploadOrgLogoPromise,
  });

  const { enqueueErrorNotification } = useNotification();

  const uploadOrgLogoAsync = async (param: UploadOrgLogoParam) => {
    try {
      const res = await mutateAsync(param);
      return res;
    } catch (err) {
      console.error(err);
      enqueueErrorNotification((err as Error).message || 'Error uploading logo');
      return null;
    }
  };

  return {
    uploadOrgLogoAsync,
  };
};
